<template>
  <div class="userstate">
    <signModule :isUserInfo="true"></signModule>
  </div>
</template>

<script>
import signModule from '../../components/signModule.vue'
export default {
  name: 'userstate',
  components: {
    signModule
  },
  props: {
    
  },
  data() {
    return {
      
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  created() {
    
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>

</style>